
(function(){
"use strict";
/* ── Textes traduisibles : remplis par Liquid (locales/*.json > ldi18n.js_pack) ── */
var LDLOC = 'en-GB';
var LDT = {"k1": "2-in-1 Duvet — Fully Washable", "k2": "2-in-1 Duvet — Fully Washable", "k3": "Guest bed & sofa bed", "k4": "narrow single bed · 1 person", "k5": "Single bed", "k6": "bed 90 to 120 cm wide · 1 person", "k7": "Single bed XL", "k8": "extra long · 1 person", "k9": "Double bed", "k10": "bed 140 cm wide · 2 people", "k11": "Large double bed", "k12": "bed 160 cm wide · 2 people", "k13": "Extra-large bed (super king)", "k14": "bed 180 cm or wider · 2 people", "k15": "Buy 1", "k16": "Buy 2", "k17": "", "k18": "Buy 3", "k19": "", "k20": "Jan", "k21": "Feb", "k22": "Mar", "k23": "Apr", "k24": "May", "k25": "Jun", "k26": "Jul", "k27": "Aug", "k28": "Sept", "k29": "Oct", "k30": "Nov", "k31": "Dec", "k32": "1", "k33": "between {a} and {b}", "k34": "Sold out", "k35": "Most popular", "k36": "+ {n} free pillowcases", "k100": "Most popular size", "k101": "Popular size", "k102": "Ships within 24&nbsp;h", "k92": "You save {e}", "k93": "", "k94": "{p} / duvet", "k95": "Best deal", "k96": "{n} matching pillowcases", "k97": "Free", "k98": "Delivery", "k99": "Free delivery", "k37": "Colour and size", "k38": "Which size should I choose?", "k39": "Colour", "k40": "Size", "k41": "Size guide", "k42": "Close", "k43": "Suits", "k44": "Apply to all duvets", "k45": "<b>Torn between two sizes?</b> Go for the larger one. A duvet that’s too snug lets the cold in at the sides. Measure the width of the bed, not just the mattress.", "k46": "Duvet no. {n} · choose based on the width of your bed.", "k47": "Choose based on the width of your bed, not the mattress.", "k48": "Most popular", "k49": "Order summary", "k50": "Basket", "k51": "NOVEMBER OFFER 🍁", "k52": "Discount", "k53": "Delivery", "k54": "Checkout", "k55": "Guarantees", "k56": "Secure payment", "k57": "100-night trial", "k58": "Money-back guarantee", "k59": "One moment...", "k60": "Add-on product", "k61": "This item is temporarily unavailable.", "k62": "Couldn’t add to basket", "k63": "Couldn’t add to basket. Please try again.", "k64": "Enlarged photo", "k65": "Add to your order", "k66": "Loading product…", "k67": "You may also like", "k68": "This item is temporarily unavailable.", "k69": "Enlarge photo", "k70": "{prix} for {n}", "k71": "Quantity", "k72": "Decrease quantity", "k73": "Increase quantity", "k74": "Unavailable", "k75": "Add", "k76": "Your basket is empty.", "k77": "Free", "k78": "Free", "k79": "Remove", "k80": "Pillowcase colour", "k81": "Duvet colour", "k82": "Quantity: {n}", "k83": "Qty", "k84": "Only <b>{prix}</b> away from free delivery", "k85": "Free pillowcases", "k86": "Free delivery", "k87": "Free", "k88": "Calculated at checkout", "k89": "Estimated {date}", "k90": "This combination is unavailable.", "k91": "Buy now"};
function ldf(s,o){ return String(s).replace(/\{(\w+)\}/g,function(m,k){ return Object.prototype.hasOwnProperty.call(o,k)?String(o[k]):m; }); }
var LDCOL = {"blanc": "White", "beige": "Beige", "noir": "Black", "rouge": "Red", "bleu claire": "Light blue", "marron": "Brown", "gris": "Grey", "vert": "Green", "bleu fonce": "Dark blue", "bleu clair": "Light blue", "bleu nuit": "Dark blue", "orange": "Orange", "violet": "Purple"};
function ldc(s){ var t=LDCOL[cfr(s)]; return (t&&norm(t)!==norm(s))?t:s; }   /* libelle de couleur affiche ; la valeur reste en francais */
var root=document.getElementById('cfb'); if(!root) return;
/* ── COULEURS MULTILINGUES ──────────────────────────────────────────
   Les variantes peuvent arriver traduites (Bianco, Blanco, White, Weiß…).
   cfr() ramène toute couleur à sa clé FRANÇAISE canonique (celle des
   variantes françaises, sans accent, en minuscules) ; ckey/exclue/taie/
   rupture et les photos passent toutes par elle. Fonctionne avant ET
   après la traduction des couleurs dans Shopify. */
var LDREV = {
  "blanc":"blanc","bianco":"blanc","blanco":"blanc","white":"blanc","weiss":"blanc","weiß":"blanc",
  "noir":"noir","nero":"noir","negro":"noir","black":"noir","schwarz":"noir",
  "rouge":"rouge","rosso":"rouge","rojo":"rouge","red":"rouge","rot":"rouge",
  "bleu claire":"bleu claire","azzurro":"bleu claire","azul claro":"bleu claire","light blue":"bleu claire","hellblau":"bleu claire","celeste":"bleu claire","blu chiaro":"bleu claire",
  "marron":"marron","marrone":"marron","brown":"marron","braun":"marron",
  "gris":"gris","grigio":"gris","grey":"gris","gray":"gris","grau":"gris",
  "vert":"vert","verde":"vert","green":"vert","grun":"vert","gruen":"vert",
  "bleu fonce":"bleu fonce","blu scuro":"bleu fonce","azul oscuro":"bleu fonce","dark blue":"bleu fonce","dunkelblau":"bleu fonce",
  "beige":"beige",
  "orange":"orange","arancione":"orange","naranja":"orange","oranje":"orange",
  "violet":"violet","viola":"violet","morado":"violet","purple":"violet","lila":"violet","lilla":"violet","paars":"violet"
};
function cnorm(s){ return String(s==null?'':s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').trim(); }
/* les libellés traduits du thème (LDCOL) comptent aussi comme alias */
Object.keys(LDCOL).forEach(function(k){ var t=cnorm(LDCOL[k]); if(t&&!LDREV[t]) LDREV[t]=k; });
function cfr(s){ var k=cnorm(s); return LDREV[k]||k; }
var DATA; try{ DATA=JSON.parse(document.getElementById('cfb-data').textContent); }catch(e){ return; }
/* ══════════════ CONFIG ══════════════ */
/* TEST 1 — redirection directe vers le paiement.
   true  = "Ajouter au panier" envoie droit au checkout, sans tiroir.
   false = comportement normal (le tiroir s'ouvre).
   Le tiroir reste actif pour l'icône panier du thème dans les deux cas. */
var DIRECT_CHECKOUT = false;
var TITRES = { 1:LDT.k1, 2:LDT.k2 };
var TAIES = {
  "blanc":      { id:59086977433931, dot:"#FFFFFF"},
  "beige":      { id:59086977466699, dot:"#E0D2BC"},
  "gris":       { id:59086977630539, dot:"#A6A6AC"},
  "noir":       { id:59086977499467, dot:"#2B2B2E"},
  "marron":     { id:59086977597771, dot:"#6D5140"},
  "bleu clair": { id:59086977565003, dot:"#A9C4DA"},
  "bleu nuit":  { id:59086977696075, dot:"#2E3F5E"},
  "rouge":      { id:59086977532235, dot:"#A03A34"},
   "vert":      { id:59086977663307, dot:"#94e4987e"}, "orange": { id:59086977728843, dot:"#E8833A"}, "violet": { id:59086977761611, dot:"#7E5A9B"}
};

var DOTS = {};
/* Autres façons d'écrire une couleur. À gauche : le nom tel qu'il apparaît
   dans les variantes (sans accent, en minuscules). À droite : la clé de TAIES. */
var ALIAS = {
  "bleu":"bleu clair", "bleu claire":"bleu clair", "bleu ciel":"bleu clair", "bleu pale":"bleu clair",
  "bleu fonce":"bleu nuit", "bleu foncee":"bleu nuit", "bleu marine":"bleu nuit", "marine":"bleu nuit", "navy":"bleu nuit",
  "blanc casse":"blanc", "ecru":"beige", "sable":"beige",
  "anthracite":"gris", "gris clair":"gris", "gris fonce":"gris",
  "taupe":"marron", "chocolat":"marron", "terracotta":"rouge", "bordeaux":"rouge"
};
/* ── GUIDE DES TAILLES ────────────────────────────────────────────────
   clé = valeur de l'option Taille, sans accent, sans espace, sans "cm"
   lit = type de lit (en gras)
   det = la précision : largeur du lit, nombre de personnes
   pop = affiche la pastille "Le + choisi"
   Pour ajouter une taille : une ligne ici + sa clé dans GUIDE_ORDRE. */
var GUIDE = {
  "90x200":  { lit:LDT.k3, det:LDT.k4 },
  "140x200": { lit:LDT.k5,                  det:LDT.k6 },
  "160x210": { lit:LDT.k7,               det:LDT.k8 },
  "200x200": { lit:LDT.k9,                 det:LDT.k10, pop:true },
  "230x230": { lit:LDT.k11,           det:LDT.k12 },
  "264x229": { lit:LDT.k13,           det:LDT.k14 }
};
/* Ordre d'affichage dans le guide, du plus petit au plus grand. */
var GUIDE_ORDRE = ["90x200","140x200","160x210","200x200","230x230","264x229"];
/* false = seules les tailles réellement créées en variante Shopify
           apparaissent dans le guide. Aucune ligne morte, aucune mention
           d'indisponibilité : tout ce qui s'affiche est achetable.
   true  = les tailles de GUIDE_ORDRE absentes des variantes s'affichent
           quand même, mais ne seront pas cliquables. */
var GUIDE_AFFICHER_TOUT = false;
var EXCLUES = ["sauge","olive","kaki"];
/* Combinaisons forcées EN RUPTURE, quel que soit le stock Shopify.
   c = couleur (les alias sont acceptés) · s = taille (espaces et "cm" ignorés).
   Pour remettre en vente : supprimer la ligne. */
var RUPTURES = [
 // { c:"beige",       s:"264x229" },
 //  { c:"gris",       s:"264x229" },
    { c:"violet", s:"200x200" },
        { c:"violet", s:"230x230" },
   { c:"orange", s:"230x230" },
      { c:"orange", s:"200x200" }
];
var SEUIL_LIVRAISON = 0;       /* Livraison offerte sans minimum d'achat. */
var FRAIS_PORT = 0;            /* Tarif France Shopify, en centimes. */
var VALEUR_LOT = 4900;   /* valeur barrée d'un LOT DE 2 taies d'oreiller, en centimes */
/* Délai de livraison affiché, en JOURS OUVRÉS (samedi et dimanche exclus).
   Les dates sont recalculées à chaque chargement de page. */
var LIVRAISON = { min:5, max:7 };

/* UPSELL PANIER — ID PRODUIT Shopify.
   Le script retrouve automatiquement une variante achetable de ce produit,
   puis utilise cette vraie variante pour /cart/add.js. */
var UPSELL_PRODUCT_ID = 16136602747211;
var UPSELL_VARIANT_ID = null;   /* résolu automatiquement */

/* Barème de remise, en euros retirés de la COMMANDE (pas du prix unitaire).
   Doit correspondre EXACTEMENT aux réductions automatiques Shopify. */
var REMISES = { 1:0, 2:30, 3:60, 4:80, 5:100, 6:120 };   /* 25/10 journée : remise réelle du paiement (30 €) ; passe à 20 € à minuit avec les nouveaux prix (modifier_minuit.py) */
var REMISE_MAX_QTE = 6;   /* au-delà, on reste sur la remise de 6 */
function remisePour(n){
  if(n>=REMISE_MAX_QTE) return REMISES[REMISE_MAX_QTE];
  return REMISES[n]||0;
}
/* Les 3 lignes du bundle.
   nom  = libellé de la ligne
   pack = nom du pack, repris dans la pastille d'économie ("Pack Duo · −70 €")
   pop  = badge "Meilleure vente" sur la ligne */
var OFFRES = [
  { n:1, nom:LDT.k15, pop:false },
  { n:2, nom:LDT.k16, pop:true  },
  { n:3, nom:LDT.k18, pop:false, best:true }
];
var DEFAUT = 1;   /* 0 = 1 couette · 1 = 2 couettes (pré-sélectionnée) · 2 = 3 couettes */
/* ══════════════ FIN CONFIG ══════════════ */
var CUR=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
function fmt(c){ try{ return new Intl.NumberFormat(LDLOC,{style:'currency',currency:CUR}).format(c/100); }
  catch(e){ return (c/100).toFixed(2).replace('.',',')+' €'; } }
/* montant "court" pour les pastilles : 70 € plutôt que 70,00 € quand c'est rond */
function fmt0(c){ if(CUR!=='EUR'||c%100!==0) return fmt(c); return (c/100)+' €'; }
function norm(s){ return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').trim(); }
function cap(s){ s=String(s==null?'':s); return s.charAt(0).toUpperCase()+s.slice(1); }
/* clé de couleur, alias résolus : "Bleu ciel" et "bleu clair" donnent la même clé */
function ckey(s){ var k=cfr(s); return ALIAS[k]||k; }
function exclue(c){ var k=cfr(c); return EXCLUES.some(function(x){ return k.indexOf(x)!==-1; }); }
function taie(c){ var k=cfr(c); return TAIES[k]||TAIES[ALIAS[k]]||null; }
function dotOf(c){ var t=taie(c); if(t) return t.dot; var k=cfr(c); return DOTS[k]||DOTS[ALIAS[k]]||'#DDD8EE'; }
function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(m){
  return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }
/* ---------- dates de livraison ----------
   jourOuvre(n) = aujourd'hui + n jours ouvrés. Le texte donne une fourchette
   du type "entre le 1er et le 3 sept." (le mois n'est répété que s'il change). */
var MOIS=[LDT.k20,LDT.k21,LDT.k22,LDT.k23,LDT.k24,LDT.k25,LDT.k26,LDT.k27,LDT.k28,LDT.k29,LDT.k30,LDT.k31];
function jourOuvre(n){ var x=new Date(); x.setHours(12,0,0,0);
  while(n>0){ x.setDate(x.getDate()+1); var j=x.getDay(); if(j!==0&&j!==6) n--; } return x; }
function jourTxt(x,mois){ var d=x.getDate(); return (d===1?LDT.k32:d)+(mois?' '+MOIS[x.getMonth()]:''); }
function livraisonTexte(){
  var a=jourOuvre(LIVRAISON.min), b=jourOuvre(LIVRAISON.max);
  return ldf(LDT.k33,{a:jourTxt(a,a.getMonth()!==b.getMonth()),b:jourTxt(b,true)});
}
/* clé normalisée d'une taille : "160 x 210 cm" -> "160x210" */
function gkey(t){ return norm(t).replace(/×/g,'x').replace(/cm/g,'').replace(/\s+/g,''); }
function guide(t){ return GUIDE[gkey(t)]||null; }
var on=DATA.options.map(function(o){return norm(o);});
/* options reconnues dans toutes les langues ; à défaut, par position
   (Couleur = 1re option, Dimensions = 2e, comme dans Shopify) */
var OPT_COULEUR=["couleur","colore","colori","color","colour","farbe"];
var OPT_TAILLE=["dimension","taille","misura","misure","medida","tamano","size","große","grosse","groesse","abmessung"];
function ix(ws,fb){ ws=ws.filter(Boolean).map(norm);
  for(var i=0;i<on.length;i++){ for(var j=0;j<ws.length;j++){ if(on[i].indexOf(ws[j])!==-1) return i; } } return fb; }
var ci=ix([root.dataset.colorOption].concat(OPT_COULEUR), DATA.options.length>1?0:-1);
var si=ix([root.dataset.sizeOption].concat(OPT_TAILLE), DATA.options.length>1?(ci===1?0:1):0);
if(ci===si){ if(DATA.options.length>1) si=(ci===0?1:0); else ci=-1; }
if(ci>=0){ var f=DATA.variants.filter(function(v){ return !exclue(v.options[ci]); }); if(f.length) DATA.variants=f; }
function uniq(i){var s={},o=[];DATA.variants.forEach(function(v){var x=v.options[i];if(x!=null&&!s[x]){s[x]=1;o.push(x);}});return o;}
var COLORS=ci>=0?uniq(ci):[], SIZES=si>=0?uniq(si):[];
function vFor(c,s){ return DATA.variants.find(function(v){ return (ci<0||v.options[ci]===c)&&(si<0||v.options[si]===s); }); }
/* Une combinaison listée dans RUPTURES est traitée comme épuisée,
   même si Shopify la déclare encore disponible. */
function rupture(c,s){
  if(c==null||s==null) return false;
  var ck=ckey(c), sk=gkey(s);
  return RUPTURES.some(function(r){ return ckey(r.c)===ck && gkey(r.s)===sk; });
}
function okC(c){
  if(si<0) return DATA.variants.some(function(v){ return v.options[ci]===c&&v.available; });
  return SIZES.some(function(s){ return okS(c,s); });
}
function okS(c,s){ var v=vFor(c,s); return !!(v&&v.available&&!rupture(c,s)); }
/* lignes du guide : GUIDE_ORDRE croisé avec les vraies variantes du produit */
function guideLignes(){
  var out=[], vus={};
  GUIDE_ORDRE.forEach(function(k){
    var reel=SIZES.find(function(s){ return gkey(s)===k; });
    if(reel){ vus[k]=1; out.push({v:reel,label:reel,key:k,existe:true}); }
    else if(GUIDE_AFFICHER_TOUT){ out.push({v:null,label:k.replace('x','×')+' cm',key:k,existe:false}); }
  });
  SIZES.forEach(function(s){ var k=gkey(s);
    if(!vus[k]&&GUIDE_ORDRE.indexOf(k)===-1){ vus[k]=1; out.push({v:s,label:s,key:k,existe:true}); } });
  return out;
}
/* prix barrés du récap : compare_at des couettes + valeur des lots de taies */
var CMP={}; DATA.variants.forEach(function(v){ if(v.compare) CMP[String(v.id)]=v.compare; });
var TAIE_IDS={}; Object.keys(TAIES).forEach(function(k){ TAIE_IDS[String(TAIES[k].id)]=1; });
/* Photos de la COUETTE par couleur, utilisées dans le récapitulatif.
   Les taies, elles, gardent la photo de leur variante Shopify. */var COUETTE_IMG = {
  "blanc": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-08.jpg?v=1793749641&width=1400",
  "beige": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-01.jpg?v=1793749629&width=1400",
  "gris": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-09.jpg?v=1793749643&width=1400",
  "noir": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-10.jpg?v=1793749643&width=1400",
  "marron": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-11.jpg?v=1793749645&width=1400",
  "bleu clair": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-13.jpg?v=1793749645&width=1400",
  "bleu nuit": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-14.jpg?v=1793749646&width=1400",
  "rouge": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-12.jpg?v=1793749644&width=1400",
  "vert": "https://cdn.shopify.com/s/files/1/1067/8537/4539/files/maisonsleep-en-couette-15.jpg?v=1793749647&width=1400"
};
/* id de variante couette -> photo de sa couleur */
var CV_IMG={};
if(ci>=0) DATA.variants.forEach(function(v){
  var k=cfr(v.options[ci]);
  var im=COUETTE_IMG[k]||COUETTE_IMG[ALIAS[k]];
  if(im) CV_IMG[String(v.id)]=im;
});
/* ---------- la photo de la page suit la couleur choisie dans le bundle ----------
   On essaie, dans l'ordre, tout ce qu'un thème peut proposer :
   1. le sélecteur de variante natif du thème (on le règle sur la bonne couleur
      et on déclenche "change" : le thème met à jour SA galerie, mobile compris)
   2. Dawn : <media-gallery>.setActiveMedia(id du média de la variante)
   3. galerie générique : on fait défiler jusqu'au média, ou on clique sa vignette
   4. dernier recours : on remplace toutes les grandes photos produit de la
      section par l'image de la variante (ou la photo COUETTE_IMG de la couleur) */
function scrollParent(el){
  var n=el.parentElement;
  while(n&&n!==document.body){
    var st=getComputedStyle(n);
    if(/(auto|scroll)/.test(st.overflowX)&&n.scrollWidth>n.clientWidth+4) return n;
    n=n.parentElement;
  }
  return null;
}
var SEC=root.closest('.shopify-section')||root.closest('section')||root.closest('[class*="product"]')||document.body;
function fire(el){ try{ el.dispatchEvent(new Event('input',{bubbles:true})); el.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){} }
/* 1. sélecteur natif du thème */
function pickerSet(v){
  var done=false;
  var scope=SEC.querySelectorAll('variant-selects,variant-radios,variant-picker,variant-swatches,.product-form__input,[data-variant-picker],[data-product-options]');
  if(!scope.length) scope=[SEC];
  var i, j;
  for(i=0;i<scope.length;i++){
    var box=scope[i]; if(root.contains(box)) continue;
    for(j=0;j<v.options.length;j++){
      var val=v.options[j], nval=norm(val);
      /* <select> dont une option correspond à la valeur */
      var sels=box.querySelectorAll('select:not([name="id"])');
      var k; for(k=0;k<sels.length;k++){
        var sl=sels[k], opt=[].slice.call(sl.options).find(function(o){ return norm(o.value)===nval||norm(o.textContent)===nval; });
        if(opt){ if(sl.value!==opt.value){ sl.value=opt.value; fire(sl); } done=true; break; }
      }
      /* <input type=radio> dont la valeur correspond */
      var rads=box.querySelectorAll('input[type="radio"]');
      for(k=0;k<rads.length;k++){
        var rd=rads[k];
        if(norm(rd.value)===nval){ if(!rd.checked){ rd.checked=true; fire(rd); try{ rd.click(); }catch(e){} } done=true; break; }
      }
    }
  }
  /* champ caché id de variante, s'il existe */
  var hid=SEC.querySelectorAll('input[name="id"],select[name="id"]');
  for(i=0;i<hid.length;i++){ if(!root.contains(hid[i])&&String(hid[i].value)!==String(v.id)){ hid[i].value=v.id; fire(hid[i]); } }
  return done;
}
/* 4. remplacement direct des grandes photos */
function swapImages(src){
  if(!src) return false;
  var imgs=[].slice.call(SEC.querySelectorAll('img')).filter(function(im){
    if(root.contains(im)) return false;
    var r=im.getBoundingClientRect();
    return r.width>140||(im.naturalWidth>400&&im.offsetParent!==null);
  });
  if(!imgs.length) imgs=[].slice.call(document.querySelectorAll('.product__media img,.product__media-item img,.product-single__photo img,.product__main-photos img,.product-gallery img,.product-images img')).filter(function(im){ return !root.contains(im); });
  if(!imgs.length) return false;
  imgs.forEach(function(im){
    var pic=im.parentElement;
    if(pic&&pic.tagName==='PICTURE') pic.querySelectorAll('source').forEach(function(so){ so.removeAttribute('srcset'); });
    im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.removeAttribute('data-srcset'); im.removeAttribute('data-src');
    im.src=src;
  });
  return true;
}
function showColor(v){
  if(!v) return;
  var mid=v.media?String(v.media):'';
  try{ var u=new URL(window.location.href); u.searchParams.set('variant',v.id); history.replaceState(null,'',u.toString()); }catch(e){}
  var k=ci>=0?cfr(v.options[ci]):'';
  var src=v.img||COUETTE_IMG[k]||COUETTE_IMG[ALIAS[k]]||'';
  var picked=pickerSet(v);
  if(mid){
    if(picked) return;   /* le thème gère sa galerie */
    var gal=document.querySelector('media-gallery,[id^="MediaGallery-"]');
    if(gal&&typeof gal.setActiveMedia==='function'){
      var sec=gal.dataset.section||(gal.id||'').replace(/^MediaGallery-/,'');
      try{ gal.setActiveMedia(sec+'-'+mid,true); return; }catch(e2){}
    }
    var el=document.querySelector('[data-media-id$="-'+mid+'"],[data-media-id="'+mid+'"]');
    if(el){
      var sp=scrollParent(el);
      if(sp){ try{ sp.scrollTo({left:el.offsetLeft-sp.offsetLeft,behavior:'smooth'}); }catch(e3){ sp.scrollLeft=el.offsetLeft; } return; }
      var th=document.querySelector('[data-target$="-'+mid+'"] button,[data-target="'+mid+'"] button,button[data-media-id$="-'+mid+'"]');
      if(th){ th.click(); return; }
    }
  }
  /* pas de média sur la variante, ou galerie inconnue : on remplace la photo nous-mêmes */
  swapImages(src);
}
var E={off:DEFAUT,l:[],taies:true};   /* taies : toujours incluses */
function defL(){ var c=COLORS.find(function(x){ return cfr(x)==='beige'&&okC(x); })||COLORS[0]||null; return {c:c,s:(SIZES.find(function(x){return okS(c,x);})||SIZES[0]||null)}; }
/* les nouvelles lignes copient la couleur et la taille de la précédente :
   celui qui passe de 1 à 2 couettes veut presque toujours la même chose */
function sync(){
  var n=OFFRES[E.off].n;
  while(E.l.length<n){
    var b=E.l[E.l.length-1], d=defL();
    var c=b?b.c:d.c, s=b?b.s:d.s;
    if(!okS(c,s)){ c=d.c; s=d.s; }
    E.l.push({c:c,s:s});
  }
  E.l.length=n;
}
function tot(i){ var o=OFFRES[i],t=0;
  for(var k=0;k<o.n;k++){ var l=E.l[k]||defL(); var v=vFor(l.c,l.s); t+=v?v.price:0; }
  return Math.max(0,t-remisePour(o.n)*100); }
function bar(i){ var o=OFFRES[i],t=0;
  for(var k=0;k<o.n;k++){ var l=E.l[k]||defL(); var v=vFor(l.c,l.s); t+=v?(v.compare||v.price):0; } return t; }
/* ---------- en-tête ---------- */
var titleEl=root.querySelector('[data-cfb-title]'),
    priceEl=root.querySelector('[data-cfb-price]'),
    compEl =root.querySelector('[data-cfb-comp]'),
    promoEl=root.querySelector('[data-cfb-promo]');
var BASE=titleEl.textContent.trim();
/* L'en-tête montre TOUJOURS le titre et le prix d'UNE couette,
   quelle que soit l'offre sélectionnée : afficher le prix du pack
   en gros avant que le visiteur ait compris l'offre le fait fuir.
   Le prix suit en revanche la TAILLE choisie sur la ligne n°1. */
function head(){
  var txt=TITRES[1]||BASE;
  if(titleEl.textContent!==txt){
    titleEl.style.opacity='0';
    setTimeout(function(){ titleEl.textContent=txt; titleEl.style.opacity='1'; },140);
  }
  var l=E.l[0]||defL(), v=vFor(l.c,l.s);
  var t=v?v.price:0, b=v?(v.compare||0):0;
  priceEl.textContent=fmt(t);
  if(b>t){ compEl.hidden=false; compEl.textContent=fmt(b); if(promoEl) promoEl.hidden=false; }
  else { compEl.hidden=true; if(promoEl) promoEl.hidden=true; }
}
/* ---------- menu déroulant ---------- */
var PANEL=null,PBTN=null,RAF=null;
function killPanel(){ if(RAF){cancelAnimationFrame(RAF);RAF=null;}
  if(PANEL){PANEL.remove();PANEL=null;} if(PBTN){PBTN.setAttribute('aria-expanded','false');PBTN=null;} }
function place(resize){ if(!PANEL||!PBTN) return;
  var r=PBTN.getBoundingClientRect();
  var below=window.innerHeight-r.bottom-8,above=r.top-8;
  if(resize!==false){
    /* le panneau épouse son contenu : jamais plus étroit que le bouton,
       jamais plus large que ce qu'il a à montrer */
    PANEL.style.width='auto';
    PANEL.style.minWidth=r.width+'px';
    PANEL.style.maxWidth='calc(100vw - 16px)';
    PANEL.style.maxHeight=Math.min(300,Math.max(below,above,160))+'px';
  }
  var w=PANEL.offsetWidth,h=PANEL.offsetHeight;
  PANEL.style.left=Math.max(8,Math.min(r.left,window.innerWidth-w-8))+'px';
  PANEL.style.top=((below<h&&above>below)?Math.max(8,r.top-h-4):r.bottom+4)+'px'; }
function onScroll(e){
  if(!PANEL) return;
  var t=e&&e.target;
  if(t&&t.nodeType===1&&(t===PANEL||PANEL.contains(t))) return;
  if(RAF) return;
  RAF=requestAnimationFrame(function(){
    RAF=null; if(!PANEL||!PBTN) return;
    var r=PBTN.getBoundingClientRect();
    if(r.bottom<0||r.top>window.innerHeight){ killPanel(); return; }
    place(false);
  });
}
window.addEventListener('scroll',onScroll,true);
window.addEventListener('resize',killPanel);
document.addEventListener('click',function(e){ if(PANEL&&!PANEL.contains(e.target)) killPanel(); });
document.addEventListener('keydown',function(e){ if(e.key==='Escape') killPanel(); });
function dd(kind,label,cur,items,pick){
  var w=document.createElement('div'); w.className='cfb-dd '+kind;
  var b=document.createElement('button'); b.type='button'; b.className='cfb-db';
  b.setAttribute('aria-haspopup','listbox'); b.setAttribute('aria-expanded','false'); b.setAttribute('aria-label',label);
  var c=items.find(function(x){return x.v===cur;})||items[0]||{t:'–'};
  b.innerHTML=(c.dot?'<i class="cfb-dot" style="background:'+c.dot+'"></i>':'')+
    '<span>'+esc(c.t||'–')+'</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
  b.onclick=function(e){ e.stopPropagation();
    if(PBTN===b){ killPanel(); return; }
    killPanel();
    /* le panneau porte le même "kind" que son bouton : le panier a un menu compact */
    var p=document.createElement('div'); p.className='cfb-dp '+kind; p.setAttribute('role','listbox');
    items.forEach(function(it){
      var o=document.createElement('button'); o.type='button';
      o.className='cfb-do'+(it.v===cur?' on':'')+(it.off?' off':'');
      o.setAttribute('role','option'); o.setAttribute('aria-selected',it.v===cur?'true':'false');
      if(it.off) o.setAttribute('aria-disabled','true');
      o.innerHTML=(it.dot?'<i class="cfb-dot" style="background:'+it.dot+'"></i>':'')+
        '<span>'+esc(it.t)+'</span>'+(it.off?'<em class="cfb-so">'+LDT.k34+'</em>':'');
      o.onclick=function(ev){ ev.stopPropagation(); if(it.off) return; killPanel(); pick(it.v); };
      p.appendChild(o);
    });
    document.body.appendChild(p); PANEL=p; PBTN=b; b.setAttribute('aria-expanded','true'); place(); };
  w.appendChild(b); return w;
}
/* ---------- rendu ----------
   Une LIGNE par offre. La ligne sélectionnée s'ouvre et contient les
   menus Couleur / Taille de chacune de ses couettes. */
var BUNDLE_IMG={
  "blanc":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-blanc.png?v=1793750747",
  "beige":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-beige.png?v=1793750746",
  "gris":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-gris.png?v=1793750746",
  "noir":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-noir.png?v=1793750747",
  "marron":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-marron.png?v=1793750747",
  "bleu clair":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-bleuclair.png?v=1793750746",
  "bleu nuit":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-bleunuit.png?v=1793750747",
  "rouge":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-rouge.png?v=1793750747",
  "vert":"\/\/cdn.shopify.com\/s\/files\/1\/1067\/8537\/4539\/files\/maisonsleep-pack-vert.png?v=1793750746"
};
var LAST_OFF=-1;
function go(){
  killPanel(); sync();
  var box=root.querySelector('.cfb-offres');
  var hadFocus=box.contains(document.activeElement);
  var switched=LAST_OFF!==E.off; LAST_OFF=E.off;
  box.innerHTML='';
  OFFRES.forEach(function(of,i){
    var sel=i===E.off, t=tot(i), b=bar(i), ec=Math.max(0,b-t);
    var c=document.createElement('div');
    c.className='cfb-c'+(sel?' on':'');
    c.innerHTML=
      (of.pop?'<span class="cfb-tag">'+LDT.k35+'</span>':'')+
      (of.best?'<span class="cfb-tag cfb-tag-best">'+LDT.k95+'</span>':'')+
      '<button type="button" class="cfb-c-head" role="radio" aria-checked="'+(sel?'true':'false')+'"'+
        ' aria-label="'+esc(of.nom)+' — '+esc(fmt(t))+'">'+
        '<span class="cfb-ck" aria-hidden="true"></span>'+
        '<span class="cfb-mid">'+
          '<span class="cfb-ttl"><span class="cfb-qty">'+esc(of.nom)+'</span>'+
            '<em class="cfb-chip">'+ldf(LDT.k36,{n:(of.n*2)})+'</em>'+
          '</span>'+
          '<span class="cfb-sub">'+(ec>0?ldf(LDT.k92,{e:fmt0(ec)}):'')+'</span>'+
        '</span>'+
        '<span class="cfb-right">'+
          '<span class="cfb-px-l"><b class="cfb-px">'+fmt(t)+'</b>'+
          (b>t?'<s class="cfb-pxs">'+fmt(b)+'</s>':'')+'</span>'+
          (of.n>1?'<span class="cfb-per good">'+ldf(LDT.k94,{p:fmt(Math.round(t/of.n))})+'</span>':'')+
        '</span>'+
      '</button>';
    /* tout clic sur la ligne sélectionne l'offre ; si elle l'est déjà, rien
       ne se passe (les menus déroulants gèrent eux-mêmes leurs clics) */
    c.addEventListener('click',function(){ if(E.off!==i){ E.off=i; go(); } });
    /* la ligne choisie s'ouvre : couleur et taille de chaque couette */
    if(sel){
      var conf=document.createElement('div'); conf.className='cfb-conf'+(switched?' anim':'');
      conf.insertAdjacentHTML('beforeend',
        '<p class="cfb-lb"><span>'+LDT.k37+'</span>'+
          '<button type="button" class="cfb-guide" data-guide>'+
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
            '<circle cx="12" cy="12" r="9.5"/><path d="M9.3 9.2a2.8 2.8 0 0 1 5.4.9c0 1.9-2.7 2.4-2.7 3.9"/><path d="M12 17.6h.01"/></svg>'+
            LDT.k38+'</button></p>');
      for(var k=0;k<of.n;k++){ (function(k){
        var l=E.l[k];
        var row=document.createElement('div'); row.className='cfb-row';
        var fc=document.createElement('div'); fc.className='cfb-fld is-c';
        fc.insertAdjacentHTML('beforeend','<span class="cfb-fl">'+LDT.k39+'</span>');
        fc.appendChild(dd('is-c',LDT.k39,l.c,COLORS.map(function(cc){ return {v:cc,t:ldc(cc),dot:dotOf(cc),off:!okC(cc)}; }),
          function(v){ l.c=v; if(!okS(l.c,l.s)) l.s=SIZES.find(function(x){return okS(l.c,x);})||l.s; go(); showColor(vFor(l.c,l.s)); }));
        var fs=document.createElement('div'); fs.className='cfb-fld is-s';
        fs.insertAdjacentHTML('beforeend','<span class="cfb-fl">'+LDT.k40+'</span>');
        fs.appendChild(dd('is-s',LDT.k40,l.s,SIZES.map(function(sz){ return {v:sz,t:sz,off:!okS(l.c,sz)}; }),
          function(v){ l.s=v; go(); }));
        row.appendChild(fc); row.appendChild(fs);
        var li=document.createElement('div'); li.className='cfb-bl';
        li.innerHTML='<img class="cfb-bl-img" src="'+esc(BUNDLE_IMG[ckey(l.c)]||'')+'" alt="'+esc(ldc(l.c))+'" width="110" height="110">'+
          '<div class="cfb-bl-r"><span class="cfb-bl-n">Duvet '+(k+1)+'</span></div>';
        li.querySelector('.cfb-bl-r').appendChild(row);
        conf.appendChild(li);
      })(k); }
      var fp=t>=SEUIL_LIVRAISON;
      var hk=E.l.slice(0,of.n).map(function(x){ return x?gkey(x.s):''; });
      var hot=hk.indexOf('230x230')>-1?LDT.k100:((hk.indexOf('200x200')>-1||hk.indexOf('264x229')>-1)?LDT.k101:'');
      conf.insertAdjacentHTML('beforeend',
        (hot?'<p class="cfb-hot"><span aria-hidden="true">🔥</span> '+hot+'</p>':'')+
        '<p class="cfb-xl-ship'+(fp?' free':'')+'">'+
          (fp?LDT.k99+(FRAIS_PORT>0?' <s>'+fmt(FRAIS_PORT)+'</s>':''):LDT.k98+' '+fmt(FRAIS_PORT))+
          ' <span class="cfb-24">· '+LDT.k102+'</span></p>');
      var gb=conf.querySelector('[data-guide]');
      if(gb) gb.onclick=function(e){ e.stopPropagation(); guideOpen(0); };
      c.appendChild(conf);
    }
    box.appendChild(c);
  });
  if(hadFocus){
    var hb=box.querySelector('.cfb-c.on .cfb-c-head');
    if(hb){ try{ hb.focus({preventScroll:true}); }catch(e){} }
  }
  head();
}
/* ══════════ GUIDE DES TAILLES ══════════ */
var GD=null, GD_ROW=0;
function buildGuide(){
  if(GD) return GD;
  var d=document.createElement('div'); d.className='cfb-gd'; d.hidden=true;
  d.innerHTML='<div class="cfb-gd-ov" data-gclose></div>'+
    '<div class="cfb-gd-p" role="dialog" aria-modal="true" aria-label="'+esc(LDT.k41)+'">'+
      '<span class="cfb-gd-grab" aria-hidden="true"></span>'+
      '<header class="cfb-gd-h">'+
        '<div class="cfb-gd-ht"><b>'+LDT.k38+'</b><span data-gsub></span></div>'+
        '<button type="button" class="cfb-gd-x" data-gclose aria-label="'+esc(LDT.k42)+'">'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>'+
        '</button></header>'+
      '<div class="cfb-gd-hd" aria-hidden="true"><span>'+LDT.k40+'</span><span>'+LDT.k43+'</span></div>'+
      '<div class="cfb-gd-b" data-grows></div>'+
      '<footer class="cfb-gd-f">'+
        '<label class="cfb-gd-all" data-gall hidden><input type="checkbox"><span>'+LDT.k44+'</span></label>'+
        '<p class="cfb-gd-tip">'+LDT.k45+'</p>'+
      '</footer></div>';
  document.body.appendChild(d);
  d.querySelectorAll('[data-gclose]').forEach(function(el){ el.addEventListener('click',guideClose); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&GD&&!GD.hidden) guideClose(); });
  GD=d; return d;
}
/* Applique une taille SANS jamais afficher d'indisponibilité :
   si la couleur en cours n'a pas cette taille, on bascule en silence
   sur une couleur qui l'a. Le visiteur ne rencontre jamais de mur. */
function appliqueTaille(sz,toutes){
  var cibles = toutes ? E.l : [E.l[GD_ROW]];
  cibles.forEach(function(x){
    if(!x) return;
    x.s=sz;
    if(!okS(x.c,sz)){
      var c2=COLORS.find(function(c){ return okS(c,sz); });
      if(c2) x.c=c2;
    }
  });
}
function guideClose(){ if(GD){ GD.hidden=true; if(!DW||DW.hidden) document.documentElement.style.overflow=''; } }
function guideOpen(row){
  var o=OFFRES[E.off];
  GD_ROW=Math.min(Math.max(typeof row==='number'?row:0,0),o.n-1);
  var d=buildGuide(), l=E.l[GD_ROW]||defL();
  var all=d.querySelector('[data-gall]'), body=d.querySelector('[data-grows]');
  d.querySelector('[data-gsub]').textContent = o.n>1
    ? ldf(LDT.k46,{n:(GD_ROW+1)})
    : LDT.k47;
  all.hidden = o.n<2;
  if(!all.hidden) all.querySelector('input').checked=false;
  body.innerHTML='';
  guideLignes().forEach(function(g){
    var m=GUIDE[g.key]||{lit:g.label,det:''};
    var sel=g.existe&&g.v===l.s;
    var b=document.createElement('button'); b.type='button';
    b.className='cfb-gd-r'+(sel?' on':'');
    b.setAttribute('aria-pressed',sel?'true':'false');
    if(!g.existe) b.disabled=true;
    b.innerHTML='<span class="cfb-gd-sz">'+esc(g.label)+'</span>'+
      '<span class="cfb-gd-d"><b>'+esc(m.lit)+'</b><i>'+esc(m.det)+'</i></span>'+

      '<span class="cfb-gd-ck" aria-hidden="true"></span>';
    if(g.existe) b.onclick=function(){
      appliqueTaille(g.v, !all.hidden&&all.querySelector('input').checked);
      guideClose(); go();
    };
    body.appendChild(b);
  });
  d.hidden=false; document.documentElement.style.overflow='hidden';
  var x=d.querySelector('.cfb-gd-x'); if(x){ try{ x.focus({preventScroll:true}); }catch(err){} }
}
/* ══════════ RÉCAPITULATIF ══════════ */
var DW=null;
function buildDrawer(){
  if(DW) return DW;
  var d=document.createElement('div'); d.className='cfb-dw'; d.hidden=true;
  d.innerHTML='<div class="cfb-dw-ov" data-close></div>'+
    '<aside class="cfb-dw-p" role="dialog" aria-modal="true" aria-label="'+esc(LDT.k49)+'">'+
      '<header class="cfb-dw-h"><span class="cfb-dw-ok" data-cart-title>'+LDT.k50+'</span>'+
        '<button type="button" class="cfb-dw-x" data-close aria-label="'+esc(LDT.k42)+'">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></header>'+
      '<div class="cfb-dw-prog" data-prog></div>'+
      '<div class="cfb-dw-b">'+
        '<div data-lines></div>'+
        '<div class="cfb-upsell" data-upsell aria-live="polite"></div>'+
      '</div>'+
      '<footer class="cfb-dw-f">'+
        /* encart à part : l'offre, la réduction et la livraison, détachés du bouton */
        '<div class="cfb-dw-tr" data-terms>'+
          '<em class="cfb-dw-badge" data-badge>'+
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
            '<path d="M20.6 13.4 12.4 21.6a2 2 0 0 1-2.8 0l-7.2-7.2a2 2 0 0 1-.6-1.4V4a2 2 0 0 1 2-2h9a2 2 0 0 1 1.4.6l6.4 6.4a2 2 0 0 1 0 2.8z"/>'+
            '<circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none"/></svg>'+
            LDT.k51+'</em>'+
          '<div class="cfb-dw-tr-l" data-red-row><span>'+LDT.k52+'</span><b data-red></b></div>'+
          '<div class="cfb-dw-tr-l"><span>'+LDT.k53+'<small data-ship-est></small></span><b data-ship></b></div>'+
        '</div>'+
        '<button type="button" class="cfb-dw-go" data-checkout>'+
          '<svg class="cfb-dw-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
            '<rect x="4" y="10.5" width="16" height="11" rx="2.5"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>'+
          '<span>'+LDT.k54+'</span><i class="cfb-dw-go-sep"></i>'+
          '<b data-co-tot></b><s data-co-bar></s>'+
        '</button>'+
        /* réassurance sous le bouton */
        '<ul class="cfb-dw-rea" aria-label="'+esc(LDT.k55)+'">'+
          '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10.5" width="16" height="11" rx="2.5"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>'+LDT.k56+'</li>'+
          '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'+LDT.k57+'</li>'+
          '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>'+LDT.k58+'</li>'+
        '</ul>'+
      '</footer></aside>';
  document.body.appendChild(d);
  d.querySelectorAll('[data-close]').forEach(function(el){ el.addEventListener('click',closeDrawer); });
  d.querySelector('[data-checkout]').addEventListener('click',function(){
    this.disabled=true; this.textContent=LDT.k59;
    var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    if(r.charAt(r.length-1)!=='/') r+='/'; window.location.href=r+'checkout?locale=en'; });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&DW&&!DW.hidden) closeDrawer(); });
  DW=d; return d;
}
function closeDrawer(){ if(DW){ killPanel(); DW.hidden=true; document.documentElement.style.overflow=''; } }
/* ── Couleurs proposées pour une ligne du panier ──────────────────────
   Couette : toutes les couleurs disponibles DANS LA MÊME TAILLE.
   Taie    : tout le nuancier TAIES.
   Renvoie null si la ligne n'est ni l'un ni l'autre (autre produit). */
function cartColors(vid){
  var s=String(vid);
  if(TAIE_IDS[s]){
    var cur=null;
    Object.keys(TAIES).forEach(function(k){ if(String(TAIES[k].id)===s) cur=k; });
    return { taie:true, cur:cur, items:Object.keys(TAIES).map(function(k){
      return { v:k, t:ldc(cap(k)), dot:TAIES[k].dot, id:TAIES[k].id }; }) };
  }
  if(ci<0) return null;
  var v=DATA.variants.find(function(x){ return String(x.id)===s; });
  if(!v) return null;
  var size=si>=0?v.options[si]:null, cur2=v.options[ci];
  var items=COLORS.filter(function(c){ return si<0?okC(c):okS(c,size); })
    .map(function(c){ var vv=vFor(c,size); return { v:c, t:ldc(cap(c)), dot:dotOf(c), id:vv?vv.id:null }; });
  /* la couleur en cours reste toujours visible, même si elle vient de passer en rupture */
  if(!items.some(function(x){ return x.v===cur2; }))
    items.unshift({ v:cur2, t:ldc(cap(cur2)), dot:dotOf(cur2), id:v.id });
  return { taie:false, cur:cur2, items:items };
}
/* Changer la couleur d'une ligne du panier.
   Shopify ne sait pas remplacer la variante d'une ligne : on ajoute la
   nouvelle couleur, puis on retire l'ancienne. Le retrait se fait par
   ID DE VARIANTE via /cart/update.js : c'est un identifiant stable,
   contrairement au numéro de ligne (qui bouge dès qu'un ajout réordonne
   le panier) ou à la clé de ligne. Si la nouvelle couleur était déjà
   dans le panier, Shopify fusionne les quantités sur la même ligne. */
var JSONH={'Content-Type':'application/json','Accept':'application/json'};
function swapColor(oldId,newId,qty,row){
  if(row) row.classList.add('busy');
  killPanel();
  fetch(shopRoot()+'cart/add.js',{method:'POST',headers:JSONH,
    body:JSON.stringify({items:[{id:newId,quantity:qty}]})})
    .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
    .then(function(){
      var up={}; up[String(oldId)]=0;   /* ancienne couleur → 0, quelle que soit sa ligne */
      return fetch(shopRoot()+'cart/update.js',{method:'POST',headers:JSONH,
        body:JSON.stringify({updates:up})});
    })
    .then(function(r){ if(!r.ok) throw new Error('update'); return r.json(); })
    .then(renderCart)
    .catch(function(){
      if(row) row.classList.remove('busy');
      fetch(shopRoot()+'cart.js').then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
    });
}

/* ══════════ UPSELL PANIER ══════════
   - UPSELL_PRODUCT_ID peut être un ID produit Shopify.
   - On cherche le produit dans le catalogue public, puis on récupère sa fiche
     officielle /products/{handle}.js et la première variante disponible.
   - Le produit n'est jamais un lien : seule sa photo est cliquable pour zoomer.
   - Hors panier : la proposition s'affiche TOUJOURS en bas de la liste produit.
     − / + prépare la quantité, puis "Ajouter au panier".
   - Dès qu'il est ajouté : la proposition disparaît complètement.
     Le produit devient une vraie ligne panier, forcée elle aussi EN DERNIER,
     et lui seul garde un sélecteur − / quantité / +. */
var UPSELL_INFO=null, UPSELL_LOAD=null, UPSELL_DRAFT_QTY=1, UPSELL_BUSY=false;

function shopRoot(){
  var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  return r.charAt(r.length-1)==='/'?r:r+'/';
}
function moneyCents(x){
  if(typeof x==='number') return x;
  if(x==null||x==='') return 0;
  var n=parseFloat(String(x).replace(',','.'));
  return isFinite(n)?Math.round(n*100):0;
}
function catalogProductToInfo(p,variantId){
  if(!p) return null;
  var vs=p.variants||[];
  var v=vs.find(function(x){ return String(x.id)===String(variantId); }) ||
        vs.find(function(x){ return x.available!==false; }) || vs[0];
  if(!v) return null;
  UPSELL_VARIANT_ID=v.id;
  var img=v.featured_image||p.featured_image||p.image||(p.images&&p.images[0])||'';
  if(img&&typeof img==='object') img=img.src||img.url||'';
  return {
    title:p.title||LDT.k60,
    product_title:p.title||LDT.k60,
    price:moneyCents(v.price),
    compare_at_price:moneyCents(v.compare_at_price),
    image:img||'',
    variant_id:v.id,
    available:v.available!==false,
    handle:p.handle||''
  };
}
function findUpsellInCatalog(page){
  page=page||1;
  if(page>12) return Promise.resolve(null); /* jusqu'à 3000 produits */
  var url=shopRoot()+'products.json?limit=250&page='+page;
  return fetch(url,{headers:{'Accept':'application/json'}})
    .then(function(r){ if(!r.ok) throw new Error('catalog'); return r.json(); })
    .then(function(data){
      var ps=(data&&data.products)||[], wanted=String(UPSELL_PRODUCT_ID);
      var p=ps.find(function(x){
        if(String(x.id)===wanted) return true;
        return (x.variants||[]).some(function(v){ return String(v.id)===wanted; });
      });
      if(p) return p;
      if(ps.length<250) return null;
      return findUpsellInCatalog(page+1);
    });
}
function loadUpsellInfo(){
  if(UPSELL_INFO) return Promise.resolve(UPSELL_INFO);
  if(UPSELL_LOAD) return UPSELL_LOAD;
  UPSELL_LOAD=findUpsellInCatalog(1)
    .then(function(p){
      if(!p) throw new Error('product not found');
      var wanted=String(UPSELL_PRODUCT_ID);
      var catVariant=(p.variants||[]).find(function(v){ return String(v.id)===wanted; }) ||
                     (p.variants||[]).find(function(v){ return v.available!==false; }) ||
                     (p.variants||[])[0];
      if(!catVariant) throw new Error('no variant');
      UPSELL_VARIANT_ID=catVariant.id;

      /* Une fois le handle connu, on reprend la fiche Ajax officielle :
         prix en devise de présentation, disponibilité et image de variante. */
      if(!p.handle) return catalogProductToInfo(p,catVariant.id);
      return fetch(shopRoot()+'products/'+encodeURIComponent(p.handle)+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw new Error('product ajax'); return r.json(); })
        .then(function(prod){
          var vs=prod.variants||[];
          var v=vs.find(function(x){ return String(x.id)===String(catVariant.id); }) ||
                vs.find(function(x){ return x.available!==false; }) || vs[0];
          if(!v) return catalogProductToInfo(p,catVariant.id);
          UPSELL_VARIANT_ID=v.id;
          var img=v.featured_image||prod.featured_image||(prod.images&&prod.images[0])||'';
          if(img&&typeof img==='object') img=img.src||img.url||'';
          return {
            title:prod.title||p.title||LDT.k60,
            product_title:prod.title||p.title||LDT.k60,
            price:typeof v.price==='number'?v.price:moneyCents(v.price),
            compare_at_price:typeof v.compare_at_price==='number'?v.compare_at_price:moneyCents(v.compare_at_price),
            image:img||'',
            variant_id:v.id,
            available:v.available!==false,
            handle:prod.handle||p.handle||''
          };
        })
        .catch(function(){ return catalogProductToInfo(p,catVariant.id); });
    })
    .then(function(info){ UPSELL_INFO=info; return info; })
    .catch(function(){ return null; });
  return UPSELL_LOAD;
}
function isUpsellItem(it){
  if(!it) return false;
  if(String(it.product_id||'')===String(UPSELL_PRODUCT_ID)) return true;
  return UPSELL_VARIANT_ID!=null && String(it.variant_id||it.id)===String(UPSELL_VARIANT_ID);
}
function upsellLine(cart){
  if(!cart||!cart.items) return null;
  var line=cart.items.find(isUpsellItem)||null;
  if(line&&!UPSELL_VARIANT_ID) UPSELL_VARIANT_ID=line.variant_id||line.id;
  return line;
}
function upsellImg(obj){
  if(!obj) return '';
  var x=obj.image||obj.featured_image||'';
  if(x&&typeof x==='object') x=x.src||x.url||'';
  return x||'';
}
function upsellTitle(info,line){
  if(line&&line.product_title) return line.product_title;
  if(info) return info.product_title||info.name||info.title||LDT.k60;
  return LDT.k60;
}
function upsellUnitPrice(info,line){
  if(line){
    if(typeof line.final_price==='number') return line.final_price;
    if(typeof line.price==='number') return line.price;
  }
  return info&&typeof info.price==='number'?info.price:0;
}
function upsellComparePrice(info,line,unit){
  if(line){
    var op=(typeof line.original_price==='number')?line.original_price:0;
    if(op>unit) return op;
  }
  var cp=info&&typeof info.compare_at_price==='number'?info.compare_at_price:0;
  return cp>unit?cp:0;
}
function refreshCart(){
  return fetch(shopRoot()+'cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); });
}
function changeUpsellQty(line,qty){
  if(UPSELL_BUSY||!line) return;
  UPSELL_BUSY=true; renderUpsell(LAST_CART||{items:[]});
  fetch(shopRoot()+'cart/change.js',{
    method:'POST',headers:JSONH,
    body:JSON.stringify({id:line.key,quantity:Math.max(0,qty)})
  })
  .then(function(r){ if(!r.ok) throw new Error('change'); return r.json(); })
  .then(function(cart){ UPSELL_BUSY=false; renderCart(cart); })
  .catch(function(){ UPSELL_BUSY=false; refreshCart().then(renderCart).catch(function(){ renderUpsell(LAST_CART||{items:[]}); }); });
}
function addUpsell(qty){
  if(UPSELL_BUSY) return;
  if(!UPSELL_VARIANT_ID){
    loadUpsellInfo().then(function(info){
      if(info&&UPSELL_VARIANT_ID) addUpsell(qty);
      else renderUpsell(LAST_CART||{items:[]},LDT.k61);
    });
    return;
  }
  UPSELL_BUSY=true; renderUpsell(LAST_CART||{items:[]});
  fetch(shopRoot()+'cart/add.js',{
    method:'POST',headers:JSONH,
    body:JSON.stringify({items:[{id:UPSELL_VARIANT_ID,quantity:Math.max(1,qty)}]})
  })
  .then(function(r){ return r.json().then(function(x){ return {ok:r.ok,data:x}; }); })
  .then(function(x){ if(!x.ok) throw new Error((x.data&&x.data.description)||LDT.k62); return refreshCart(); })
  .then(function(cart){ UPSELL_BUSY=false; UPSELL_DRAFT_QTY=1; renderCart(cart); })
  .catch(function(e){ UPSELL_BUSY=false; renderUpsell(LAST_CART||{items:[]},e&&e.message?e.message:LDT.k63); });
}

/* Zoom léger : uniquement la photo ouvre cette fenêtre. */
var UPSELL_ZOOM=null;
function closeUpsellZoom(){
  if(UPSELL_ZOOM){ UPSELL_ZOOM.remove(); UPSELL_ZOOM=null; }
}
function openUpsellZoom(src,alt){
  if(!src) return;
  closeUpsellZoom();
  var z=document.createElement('div'); z.className='cfb-upzoom';
  z.innerHTML='<button type="button" class="cfb-upzoom-bg" aria-label="'+esc(LDT.k42)+'"></button>'+
    '<div class="cfb-upzoom-box" role="dialog" aria-modal="true" aria-label="'+esc(LDT.k64)+'">'+
      '<button type="button" class="cfb-upzoom-x" aria-label="'+esc(LDT.k42)+'">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>'+
      '</button>'+
      '<img src="'+esc(src)+'" alt="'+esc(alt||'')+'">'+
    '</div>';
  z.querySelector('.cfb-upzoom-bg').onclick=closeUpsellZoom;
  z.querySelector('.cfb-upzoom-x').onclick=closeUpsellZoom;
  document.body.appendChild(z); UPSELL_ZOOM=z;
}
document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&UPSELL_ZOOM) closeUpsellZoom(); });

function renderUpsell(cart,error){
  var d=DW||buildDrawer(), box=d.querySelector('[data-upsell]');
  if(!box) return;

  /* Pas d'upsell dans un panier vide. Dès que le produit est réellement
     dans le panier, cette proposition disparaît : il sera rendu comme
     une ligne produit normale par renderCart(). */
  if(!cart||!cart.items||!cart.items.length){
    box.className='cfb-upsell';
    box.innerHTML='';
    return;
  }
  var line=upsellLine(cart), info=UPSELL_INFO;
  if(line){
    box.className='cfb-upsell';
    box.innerHTML='';
    return;
  }
  if(!info){
    box.className='cfb-upsell loading';
    box.innerHTML='<p class="cfb-up-kicker">'+LDT.k65+'</p><div class="cfb-up-load">'+LDT.k66+'</div>';
    loadUpsellInfo().then(function(v){
      if(v&&LAST_CART) renderCart(LAST_CART);
      else if(!v){
        box.className='cfb-upsell';
        box.innerHTML='<p class="cfb-up-kicker">'+LDT.k67+'</p><p class="cfb-up-err">'+ldf(LDT.k68,{id:esc(UPSELL_PRODUCT_ID)})+'</p>';
      }
    });
    return;
  }

  var title=upsellTitle(info,null);
  var src=upsellImg(info);
  var unit=upsellUnitPrice(info,null);
  var compare=upsellComparePrice(info,null,unit);
  var qty=UPSELL_DRAFT_QTY;
  var lineTotal=unit*qty;
  var unavailable=info&&info.available===false;

  box.className='cfb-upsell'+(UPSELL_BUSY?' busy':'');
  box.innerHTML=
    '<p class="cfb-up-kicker">'+LDT.k67+'</p>'+
    '<div class="cfb-up-card">'+
      (src?'<button type="button" class="cfb-up-img" aria-label="'+esc(LDT.k69)+'">'+
        '<img src="'+esc(src)+'" alt="'+esc(title)+'" loading="lazy">'+
        '<span class="cfb-up-mag" aria-hidden="true">'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5M10.5 7.5v6M7.5 10.5h6"/></svg>'+
        '</span></button>':'<span class="cfb-up-img cfb-up-ph"></span>')+
      '<div class="cfb-up-main">'+
        '<p class="cfb-up-name">'+esc(title)+'</p>'+
        '<div class="cfb-up-price">'+
          (compare?'<s>'+fmt(compare)+'</s>':'')+
          '<b>'+fmt(unit)+'</b>'+
          (qty>1?'<small>'+ldf(LDT.k70,{prix:fmt(lineTotal),n:qty})+'</small>':'')+
        '</div>'+
        '<div class="cfb-up-actions">'+
          '<div class="cfb-up-step" aria-label="'+esc(LDT.k71)+'">'+
            '<button type="button" data-up-minus aria-label="'+esc(LDT.k72)+'">−</button>'+
            '<span data-up-qty>'+qty+'</span>'+
            '<button type="button" data-up-plus aria-label="'+esc(LDT.k73)+'">+</button>'+
          '</div>'+
          '<button type="button" class="cfb-up-add" data-up-add'+(unavailable?' disabled':'')+'>'+(unavailable?LDT.k74:LDT.k75)+'</button>'+
        '</div>'+
        (error?'<p class="cfb-up-err">'+esc(error)+'</p>':'')+
      '</div>'+
    '</div>';

  var im=box.querySelector('.cfb-up-img');
  if(im&&src) im.onclick=function(){ openUpsellZoom(src,title); };

  var minus=box.querySelector('[data-up-minus]'), plus=box.querySelector('[data-up-plus]');
  if(minus) minus.onclick=function(){
    if(UPSELL_BUSY) return;
    UPSELL_DRAFT_QTY=Math.max(1,UPSELL_DRAFT_QTY-1); renderUpsell(cart);
  };
  if(plus) plus.onclick=function(){
    if(UPSELL_BUSY) return;
    UPSELL_DRAFT_QTY=Math.min(20,UPSELL_DRAFT_QTY+1); renderUpsell(cart);
  };
  var add=box.querySelector('[data-up-add]');
  if(add&&!unavailable) add.onclick=function(){ addUpsell(UPSELL_DRAFT_QTY); };
}
var LAST_CART=null;

function renderCart(cart){
  killPanel();
  LAST_CART=cart;
  var d=buildDrawer(), lines=d.querySelector('[data-lines]');
  lines.innerHTML='';
  if(!cart.items||!cart.items.length){
    lines.innerHTML='<p class="cfb-dw-empty">'+LDT.k76+'</p>';
    d.querySelector('[data-prog]').innerHTML='';
    d.querySelector('[data-terms]').style.display='none';
    d.querySelector('[data-red]').textContent='';
    d.querySelector('[data-ship]').textContent='';
    d.querySelector('[data-ship-est]').textContent='';
    d.querySelector('[data-co-tot]').textContent='';
    d.querySelector('[data-co-bar]').textContent='';
  } else {
    var sous=0;
    /* Shopify place souvent le dernier article ajouté au DÉBUT de cart.items.
       On impose donc notre ordre d'affichage : tous les produits normaux d'abord,
       puis le produit upsell EN DERNIER. Cela ne change pas le panier Shopify,
       uniquement son rendu dans ce tiroir. */
    var DISPLAY_ITEMS=cart.items.filter(function(it){ return !isUpsellItem(it); })
      .concat(cart.items.filter(function(it){ return isUpsellItem(it); }));
    DISPLAY_ITEMS.forEach(function(it){
      var row=document.createElement('div'); row.className='cfb-dw-l';
      var vid=String(it.variant_id||it.id), strike=0;
      var isUp=isUpsellItem(it);

      var src=CV_IMG[vid]||it.image||'';   /* couette : photo de sa couleur · taies : photo Shopify */
      var img=src?src.replace(/(\.[a-z]+)(\?|$)/i,'_240x240_crop_center$1$2'):'';
      if(TAIE_IDS[vid]) strike=Math.round(VALEUR_LOT/2)*it.quantity;
      else if(CMP[vid]&&CMP[vid]>it.price) strike=CMP[vid]*it.quantity;
      else if(it.original_line_price>it.line_price) strike=it.original_line_price;
      var free=(it.line_price===0);
      if(!free) sous += (strike>it.line_price? strike : it.line_price);
      var co=cartColors(vid);
      /* la couleur a son propre menu : on la retire du sous-titre pour ne pas la dire deux fois */
      var sub=it.variant_title||'';
      if(isUp&&norm(sub)==='default title') sub='';
      if(co&&!co.taie&&sub){
        sub=sub.split('/').map(function(p){ return p.trim(); })
               .filter(function(p){ return p && ckey(p)!==ckey(co.cur); })
               .join(' · ');
      }
      row.innerHTML=(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'<span class="cfb-dw-ph"></span>')+
        '<div class="cfb-dw-i"><p class="cfb-dw-n">'+esc(it.product_title)+'</p>'+
          (sub?'<p class="cfb-dw-v">'+esc(sub)+'</p>':'')+
          '<div class="cfb-dw-meta"></div></div>'+
        '<div class="cfb-dw-pr">'+
          (strike>it.line_price?'<s>'+fmt(strike)+'</s>':'')+
          (free?'<b class="cfb-dw-free">'+(TAIE_IDS[vid]?LDT.k77:LDT.k78)+'</b>':'<b>'+fmt(it.line_price)+'</b>')+
        '</div>'+
        '<button type="button" class="cfb-dw-del" aria-label="'+esc(LDT.k79)+'">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
      var meta=row.querySelector('.cfb-dw-meta');
      /* menu de couleur : couette ET taies */
      if(co&&co.items.length>1&&!co.taie){
        meta.appendChild(dd('is-col',(co.taie?LDT.k80:LDT.k81),co.cur,
          co.items.map(function(x){ return { v:x.v, t:x.t, dot:x.dot, off:!x.id }; }),
          function(v){
            var pick=co.items.find(function(x){ return x.v===v; });
            if(!pick||!pick.id||String(pick.id)===vid) return;
            (function(){
  var ot=TAIES[cfr(co.cur)], nt=TAIES[cfr(v)], tq=0, cq=0;
  if(ot&&nt&&String(ot.id)!==String(nt.id)){
    cart.items.forEach(function(x){
      if(String(x.variant_id)===String(ot.id)) tq+=x.quantity;
      else if(!TAIE_IDS[String(x.variant_id)]){ var c2=cartColors(x.variant_id); if(c2&&!c2.taie&&cfr(c2.cur)===cfr(co.cur)) cq+=x.quantity; }
    });
  }
  var mv=(tq&&cq)?Math.min(tq,Math.round(tq*it.quantity/cq)):0;
  if(!mv){ swapColor(vid,pick.id,it.quantity,row); return; }
  row.classList.add('busy'); killPanel();
  fetch(shopRoot()+'cart/add.js',{method:'POST',headers:JSONH,body:JSON.stringify({items:[{id:pick.id,quantity:it.quantity},{id:nt.id,quantity:mv}]})})
    .then(function(r){ if(!r.ok) throw new Error('add'); var up={}; up[vid]=0; up[String(ot.id)]=tq-mv;
      return fetch(shopRoot()+'cart/update.js',{method:'POST',headers:JSONH,body:JSON.stringify({updates:up})}); })
    .then(function(r){ if(!r.ok) throw new Error('update'); return r.json(); })
    .then(renderCart)
    .catch(function(){ fetch(shopRoot()+'cart.js').then(function(r){ return r.json(); }).then(renderCart).catch(function(){}); });
})();
          }));
      }
      /* Quantité modifiable UNIQUEMENT pour le produit upsell.
         Toutes les autres lignes restent en lecture seule, comme avant. */
      if(isUp){
        meta.insertAdjacentHTML('beforeend',
          '<div class="cfb-up-step cfb-cart-up-step" aria-label="'+esc(LDT.k71)+'">'+
            '<button type="button" data-cart-up-minus aria-label="'+esc(LDT.k72)+'">−</button>'+
            '<span>'+it.quantity+'</span>'+
            '<button type="button" data-cart-up-plus aria-label="'+esc(LDT.k73)+'">+</button>'+
          '</div>');
        var um=row.querySelector('[data-cart-up-minus]'), up=row.querySelector('[data-cart-up-plus]');
        if(um) um.addEventListener('click',function(e){
          e.stopPropagation(); changeUpsellQty(it,Math.max(0,it.quantity-1));
        });
        if(up) up.addEventListener('click',function(e){
          e.stopPropagation(); changeUpsellQty(it,it.quantity+1);
        });
      } else {
        meta.insertAdjacentHTML('beforeend',
          '<span class="cfb-dw-q" aria-label="'+esc(ldf(LDT.k82,{n:it.quantity}))+'">'+
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
            '<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/></svg>'+
            LDT.k83+' <b>'+it.quantity+'</b></span>');
      }
      row.querySelector('.cfb-dw-del').addEventListener('click',function(){
        this.disabled=true; row.classList.add('busy');
        fetch(shopRoot()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:it.key,quantity:0})}).then(function(r){ return r.json(); })
          .then(renderCart).catch(function(){ row.classList.remove('busy'); });
      });
      lines.appendChild(row);
    });
    /* barre : cadeau débloqué + livraison offerte au-delà du seuil.
       Pas de titre quand tout est débloqué : les repères sous la barre suffisent.
       Le seul message conservé est "Plus que X €", tant que le seuil n'est pas atteint. */
    var red=Math.max(0,sous-cart.total_price);
    var tp=cart.total_price||0, reste=Math.max(0,SEUIL_LIVRAISON-tp);
    var okShip=(reste<=0), okGift=cart.items.some(function(x){ return x.line_price===0; });
    d.querySelector('[data-prog]').innerHTML=
      (okShip?'':'<p class="cfb-dw-pmsg">'+ldf(LDT.k84,{prix:fmt(reste)})+'</p>')+
      '<div class="cfb-dw-track"><span class="cfb-dw-fill'+(okShip?' done':'')+'" style="width:'+
        Math.round((SEUIL_LIVRAISON>0?Math.min(1,tp/SEUIL_LIVRAISON):1)*100)+'%"></span>'+
        '<i class="cfb-dw-mk'+(okGift?' on':'')+'" style="left:50%">🎁</i>'+
        '<i class="cfb-dw-mk'+(okShip?' on':'')+'" style="left:100%">🚚</i></div>'+
      '<div class="cfb-dw-mlab"><span class="mid'+(okGift?' on':'')+'">'+LDT.k85+'</span>'+
        '<span class="end'+(okShip?' on':'')+'">'+LDT.k86+'</span></div>';
    /* encart offre / réduction / livraison */
    var terms=d.querySelector('[data-terms]');
    terms.style.display='';
    d.querySelector('[data-badge]').hidden=red<=0;
    d.querySelector('[data-red-row]').hidden=red<=0;
    d.querySelector('[data-red]').textContent=red>0?'− '+fmt(red):'';
    var sh=d.querySelector('[data-ship]');
    sh.textContent=okShip?LDT.k87:fmt(FRAIS_PORT);
    sh.className=okShip?'ok':'';
    d.querySelector('[data-ship-est]').textContent=ldf(LDT.k89,{date:livraisonTexte()});
    d.querySelector('[data-co-tot]').textContent=fmt(cart.total_price+((okShip||!tp)?0:FRAIS_PORT));
    d.querySelector('[data-co-bar]').textContent=(sous>cart.total_price)?fmt(sous):'';
  }
  renderUpsell(cart);
  d.hidden=false; document.documentElement.style.overflow='hidden';
}
root.querySelector('.cfb-cta').addEventListener('click',function(){
  var btn=this,msg=root.querySelector('.cfb-msg');
  msg.textContent=''; msg.className='cfb-msg';
  var n={},bad=false;
  E.l.forEach(function(l){
    var v=vFor(l.c,l.s); if(!v||!v.available||rupture(l.c,l.s)){bad=true;return;}
    n[v.id]=(n[v.id]||0)+1;
    if(E.taies){ var t=taie(l.c); if(t) n[t.id]=(n[t.id]||0)+2; }   /* 2 taies par couette */
  });
  if(bad){ msg.textContent=LDT.k90; msg.className='cfb-msg err'; return; }
  var items=Object.keys(n).map(function(id){ return {id:parseInt(id,10),quantity:n[id]}; });
  btn.disabled=true; btn.classList.add('load');
  fetch(shopRoot()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){ return r.json().then(function(d){return{ok:r.ok,d:d};}); })
    .then(function(r){ if(!r.ok) throw new Error(r.d.description||LDT.k62); return fetch(shopRoot()+'cart.js'); })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      if(DIRECT_CHECKOUT){
        var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        if(r.charAt(r.length-1)!=='/') r+='/';
        window.location.href=r+'checkout?locale=en';
        return;
      }
      btn.disabled=false; btn.classList.remove('load'); renderCart(cart);
    })
    .catch(function(e){ btn.disabled=false; btn.classList.remove('load');
      msg.textContent=e.message; msg.className='cfb-msg err'; });
});
/* ---------- l'icône panier du thème ouvre CE récapitulatif ---------- */
/* 1. On neutralise le tiroir natif du thème (Dawn : <cart-drawer>).
      On remplace sa méthode open() : ça couvre le clic sur l'icône
      ET l'ouverture automatique après un ajout au panier. */
(function(){
  var css=document.createElement('style');
  css.textContent='cart-drawer,#CartDrawer,#CartDrawer-Overlay{display:none!important}';
  document.head.appendChild(css);
  function patch(){
    var CD=window.customElements&&customElements.get('cart-drawer');
    if(!CD||CD.prototype.__ld) return;
    CD.prototype.__ld=true;
    CD.prototype.open=function(){
      this.classList.remove('active','animate');
      document.body.classList.remove('overflow-hidden');
      fetch(shopRoot()+'cart.js').then(function(r){return r.json();}).then(renderCart)
        .catch(function(){ window.location.href=shopRoot()+'cart'; });
    };
    CD.prototype.close=function(){
      this.classList.remove('active','animate');
      document.body.classList.remove('overflow-hidden');
    };
  }
  patch();
  document.addEventListener('DOMContentLoaded',patch);
  window.addEventListener('load',patch);
  document.addEventListener('shopify:section:load',patch);
})();
/* 2. Filet de sécurité : clic sur l'icône panier ou sur un lien /cart */
function isCartTrigger(el){
  if(!el||!el.getAttribute) return false;
  var id=el.id||'';
  if(/cart-icon|cart-bubble|cart-drawer-toggle/i.test(id)) return true;
  var ac=el.getAttribute('aria-controls')||'';
  if(ac.toLowerCase().indexOf('cart')!==-1) return true;
  var href=el.getAttribute('href');
  if(href){ var p=href.split('?')[0].split('#')[0]; if(/\/cart\/?$/.test(p)) return true; }
  var cl=el.className; cl=(cl&&cl.baseVal!==undefined)?cl.baseVal:(cl||'');
  if(el.tagName!=='FORM'&&/cart-icon|cart-link|cart-toggle|cart-count|header__icon--cart|js-cart-open|site-header__cart/i.test(String(cl))) return true;
  return false;
}
document.addEventListener('click',function(e){
  if(PANEL&&PANEL.contains(e.target)) return;
  if(DW&&DW.contains(e.target)) return;
  if(GD&&GD.contains(e.target)) return;
  if(root.contains(e.target)) return;
  var n=e.target,hit=null;
  while(n&&n!==document){ if(isCartTrigger(n)){ hit=n; break; } n=n.parentNode; }
  if(!hit) return;
  e.preventDefault(); e.stopPropagation();
  fetch(shopRoot()+'cart.js').then(function(r){ return r.json(); }).then(renderCart)
    .catch(function(){ window.location.href=shopRoot()+'cart'; });
},true);
/* ---------- clic sur les étoiles → bloc d'avis en bas de page ---------- */
root.querySelector('.cfb-rate').addEventListener('click',function(){
  var sels=[];
  if(root.dataset.reviewsTarget) sels.push(root.dataset.reviewsTarget);
  sels=sels.concat(['#seal-review-widget','[id*="seal-review" i]','[class*="seal-review" i]',
    '[id*="trustoo" i]','[class*="trustoo" i]','[id*="vstar" i]','[id*="review" i]']);
  var el=null;
  for(var i=0;i<sels.length&&!el;i++){
    var list; try{ list=document.querySelectorAll(sels[i]); }catch(err){ continue; }
    for(var j=0;j<list.length;j++){
      var c=list[j];
      if(!root.contains(c)&&(root.compareDocumentPosition(c)&4)){ el=c; break; }
    }
  }
  if(el){ try{ el.scrollIntoView({behavior:'smooth',block:'start'}); }catch(err2){ el.scrollIntoView(); } }
  else window.scrollTo({top:document.documentElement.scrollHeight,behavior:'smooth'});
});
if(DIRECT_CHECKOUT){
  var lbl=root.querySelector('[data-cta-label]');
  if(lbl) lbl.textContent=LDT.k91;
}
/* ---------- livraison estimée au-dessus du bouton ---------- */
var shipEl=root.querySelector('[data-cfb-ship]');
if(shipEl) shipEl.textContent=livraisonTexte();
/* ---------- valeur du cadeau dans le bandeau ---------- */
var giftEl=root.querySelector('[data-cfb-giftval]');
if(giftEl) giftEl.textContent=fmt(VALEUR_LOT).replace(/[,.]00(?=\D|$)/,"");
/* API globale : le patch du thème et les autres pages passent par là */
window.LDCart = {
  open: function(){
    fetch(shopRoot()+'cart.js').then(function(r){ return r.json(); }).then(renderCart)
      .catch(function(){ window.location.href=shopRoot()+'cart'; });
  },
  render: renderCart,
  close: closeDrawer,
  guide: guideOpen
};
go();
})();
